export default __webpack_public_path__ + "static/logo-1f30cfb3d0dd46962bcce2307f8e6c2b.svg";